import React from 'react';
import { ClickableBlock } from 'features/tasks-forms';
import InnerBlock from '../../../shared/web/layout/InnerBlock';
import { useSetupAreaVersionContextRequired } from './SetupAreaVersionContext';
import useSettingsNavigator from '../../settingsNavigator';
import { InformationMessage, usePopupFormManager } from 'features/nekst-widgets';
import { ButtonSize, OptionSelectionButton, Text, usePopupManager } from 'ui-builder';
import {
  getSetupAreaVersionStatusLabel,
  getVersionStatusForMarket,
} from 'nekst-api';
import { SetupAreaVersionBreadcrumbs } from './SetupAreaBreadcrumbs';
import { UpdateVersionForm } from './versions/UpdateVersionForm';
import { DeleteSetupAreaVersionForm } from './versions/DeleteSetupAreaVersionForm';

function MarketActionsButton() {
  const popupFormManager = usePopupFormManager();
  const popupManager = usePopupManager();

  const {
    setupArea,
    setupAreaVersion
  } = useSetupAreaVersionContextRequired();

  const market = setupArea.market;

  const openEditForm = () => {
    popupFormManager.openForm((
      <UpdateVersionForm
        setupAreaId={setupArea.id}
        setupAreaVersion={setupAreaVersion}
      />
    ));
  };


  const openDeleteForm = () => {
    popupManager.openPopup((
      <DeleteSetupAreaVersionForm
        setupAreaId={setupArea.id}
        setupAreaVersion={setupAreaVersion.version}
      />
    ));
  };

  if (market) {
    return (
      <OptionSelectionButton
        text="Actions"
        options={[
          {
            value: 'edit',
            label: 'Update',
            onSelected: openEditForm
          },
          {
            value: 'delete',
            label: 'Delete',
            onSelected: () => openDeleteForm()
          }
        ]}
        size={ButtonSize.MEDIUM}
      />
    );
  }
}

function DescriptionBlock() {
  const {
    setupAreaVersion
  } = useSetupAreaVersionContextRequired();

  if (setupAreaVersion.description) {
    return (
      <InformationMessage>
        {setupAreaVersion.description}
      </InformationMessage>
    );
  } else {
    return null;
  }
}

export default function SetupAreaVersionPage() {
  const {
    setupArea,
    setupAreaVersion
  } = useSetupAreaVersionContextRequired();

  const settingsNavigator = useSettingsNavigator();

  return (
    <>
      <SetupAreaVersionBreadcrumbs setupArea={setupArea} version={setupAreaVersion.version} />
      <InnerBlock
        title={`${setupArea.name}: ${setupAreaVersion.version}`}
        titleLine2={(
          <>
            <Text bold>Publishing Status:</Text>
            {' '}
            {getSetupAreaVersionStatusLabel(getVersionStatusForMarket(setupArea))}
          </>
        )}
        headerRight={<MarketActionsButton />}
      >
        <DescriptionBlock />
        <ClickableBlock
          title={`Detail Boxes (${setupAreaVersion.numberOfDetailFields})`}
          onClick={() => {
            settingsNavigator.openAdminMarketDetailsFieldsPage(setupArea.market?.state || 'nomarket', setupArea.id, setupAreaVersion.version);
          }}
        />
        <ClickableBlock
          title={`Workflows (${setupAreaVersion.numberOfPlans})`}
          onClick={() => {
            settingsNavigator.openAdminSetupAreaPlansPage(
              setupArea.market?.state,
              setupArea.id,
              setupArea.versions[0].version
            );
          }}
        />
        {setupArea.market ? (<ClickableBlock
          title="AI Training"
          onClick={() => {
            settingsNavigator.openAdminMarketAiTrainingPage(
              setupArea.market?.state,
              setupArea.id,
              setupAreaVersion.version
            );
          }}
        />) : null}
      </InnerBlock>
    </>
  );
}
